import { createFileRoute, notFound } from "@tanstack/react-router";
//
import { PlayersListPage } from "@pages/players-list/players-list-page";

// QUERY
import { queryClient } from "@config/tanstack/tanstackQuery";
import { listPlayersQueryOpts } from "src/services/apiQueries/players";

export const Route = createFileRoute(
  "/_authenticated/app/accounts/$accountId/players",
)({
  component: PlayersListPage,
  loader: async (ctx) => {
    const accountId = parseInt(ctx.params.accountId);
    if (isNaN(accountId)) {
      throw notFound();
    }
    return await queryClient.ensureQueryData(
      listPlayersQueryOpts({
        account: accountId,
      }),
    );
  },
});
